module.exports = __webpack_public_path__ + "img/2.230a4e50.png";